/**
 * TOEIC Placement Test Questions
 * 15 questions: Part 1 Listening (1-3) + Part 5 Grammar/Vocab (4-11) + Part 6 Reading (12-15)
 */

// Part 6 Reading Passage
export const part6Passage = {
  title: 'Local Barbershop Wins State Competition',
  author: 'By Miranda Warren',
  content: `MALENDA COUNTY (January 12)—Pat and Kenny's Barbershop, —[12]— at 3949 Grand Street, has been named the best barbershop in the state by the Barber and Hairdresser's Coalition. The criteria for selection include reputation, affordability, professionalism, and accreditations.

—[13]—

Founders and owners Kenneth Webber and Patrick Miller have been best friends since childhood. —[14]— opened the shop 34 years ago. —[15]— the shop retains its old-fashioned charm, the barbers have mastered the latest styles, not just the more traditional ones. People of all ages seeking a haircut or a new style should try Pat and Kenny's Barbershop.`,
};

export const questions = [
  // ═══════════ PART 1: LISTENING (Photos) ═══════════
  {
    id: 1,
    part: 'Part 1 – Listening',
    isListening: true,
    image: '/toeic/part1/ets_toeic_2022_test_7_1.png',
    audio: '/toeic/part1/audio1.mp3',
    question: 'Look at the picture and listen to the audio. Choose the statement that best describes what you see in the picture.',
    options: [
      'A. (Listen to audio)',
      'B. (Listen to audio)',
      'C. (Listen to audio)',
      'D. (Listen to audio)',
    ],
    correctAnswer: 0, // A
  },
  {
    id: 2,
    part: 'Part 1 – Listening',
    isListening: true,
    image: '/toeic/part1/ets_toeic_2022_test_7_2.png',
    audio: '/toeic/part1/ets_toeic_2022_test_7_2.mp3',
    question: 'Look at the picture and listen to the audio. Choose the statement that best describes what you see in the picture.',
    options: [
      'A. (Listen to audio)',
      'B. (Listen to audio)',
      'C. (Listen to audio)',
      'D. (Listen to audio)',
    ],
    correctAnswer: 2, // C (placeholder - update based on actual audio)
  },
  {
    id: 3,
    part: 'Part 1 – Listening',
    isListening: true,
    image: '/toeic/part1/ets_toeic_2022_test_7_3.png',
    audio: '/toeic/part1/ets_toeic_2022_test_7_3.mp3',
    question: 'Look at the picture and listen to the audio. Choose the statement that best describes what you see in the picture.',
    options: [
      'A. (Listen to audio)',
      'B. (Listen to audio)',
      'C. (Listen to audio)',
      'D. (Listen to audio)',
    ],
    correctAnswer: 2, // C
  },

  // ═══════════ PART 5: GRAMMAR & VOCABULARY ═══════════
  {
    id: 4,
    part: 'Part 5 – Grammar',
    question: 'When she held her last meeting, Ms. Toba ______ her sales staff to perform even better next quarter.',
    options: [
      'A. encourage',
      'B. is encouraging',
      'C. encouraged',
      'D. was encouraged',
    ],
    correctAnswer: 2, // C
  },
  {
    id: 5,
    part: 'Part 5 – Grammar',
    question: 'All staff have been informed ______ the proposed partnership with ERI Finance.',
    options: [
      'A. for',
      'B. about',
      'C. to',
      'D. at',
    ],
    correctAnswer: 1, // B
  },
  {
    id: 6,
    part: 'Part 5 – Grammar',
    question: 'On Friday, Mr. Nakamura will discuss ______ ideas for supporting busy walkers.',
    options: [
      'A. his',
      'B. he',
      'C. himself',
      'D. he',
    ],
    correctAnswer: 0, // A
  },
  {
    id: 7,
    part: 'Part 5 – Vocabulary',
    question: 'The Forestry Commission was created to ______ the state\'s natural resources and wildlife.',
    options: [
      'A. allow',
      'B. manage',
      'C. succeed',
      'D. finish',
    ],
    correctAnswer: 1, // B
  },
  {
    id: 8,
    part: 'Part 5 – Grammar',
    question: 'By following established guidelines, construction workers will be able to complete their tasks ______.',
    options: [
      'A. safety',
      'B. safe',
      'C. safeness',
      'D. safely',
    ],
    correctAnswer: 3, // D
  },
  {
    id: 9,
    part: 'Part 5 – Vocabulary',
    question: 'With her numerous credentials, Dr. Kwan is highly ______ to teach medieval history at Maston University.',
    options: [
      'A. arranged',
      'B. ready',
      'C. available',
      'D. qualified',
    ],
    correctAnswer: 3, // D
  },
  {
    id: 10,
    part: 'Part 5 – Grammar',
    question: '______ at the annual technology conference is mandatory for all engineers at the Tremont Corporation.',
    options: [
      'A. Attendance',
      'B. Attend',
      'C. Attends',
      'D. Attended',
    ],
    correctAnswer: 0, // A
  },
  {
    id: 11,
    part: 'Part 5 – Vocabulary',
    question: 'The café ______ features poets, folk singers, and drama groups on its stage.',
    options: [
      'A. tightly',
      'B. occasionally',
      'C. vaguely',
      'D. realistically',
    ],
    correctAnswer: 1, // B
  },

  // ═══════════ PART 6: READING (Text Completion) ═══════════
  {
    id: 12,
    part: 'Part 6 – Reading',
    isPart6: true,
    blankNumber: 12,
    question: '[12]',
    options: [
      'A. locate',
      'B. located',
      'C. locates',
      'D. location',
    ],
    correctAnswer: 1, // B
  },
  {
    id: 13,
    part: 'Part 6 – Reading',
    isPart6: true,
    blankNumber: 13,
    question: '[13]',
    options: [
      'A. The results will be announced later this month.',
      'B. We are proud to serve our community with excellence.',
      'C. Pat and Kenny\'s shop excelled in all four categories.',
      'D. Please call in advance to schedule an appointment.',
    ],
    correctAnswer: 2, // C
  },
  {
    id: 14,
    part: 'Part 6 – Reading',
    isPart6: true,
    blankNumber: 14,
    question: '[14]',
    options: [
      'A. I',
      'B. We',
      'C. They',
      'D. He',
    ],
    correctAnswer: 2, // C
  },
  {
    id: 15,
    part: 'Part 6 – Reading',
    isPart6: true,
    blankNumber: 15,
    question: '[15]',
    options: [
      'A. While',
      'B. Despite',
      'C. Even',
      'D. Yet',
    ],
    correctAnswer: 0, // A
  },
];

/**
 * Calculate TOEIC level based on quiz score (15 questions total)
 */
export function getLevel(score) {
  if (score <= 5) {
    return {
      level: 'Beginner',
      toeicRange: 'TOEIC ~250–400',
      color: 'rose',
      description:
        'Bạn đang ở giai đoạn xây dựng nền tảng. Đây là thời điểm lý tưởng để bắt đầu với Annie — xây vững từ đầu sẽ giúp bạn tiến nhanh hơn rất nhiều.',
      roadmap:
        'Nền tảng ngữ pháp & từ vựng → Listening Part 1–2 → Reading Part 5 → Mock test định kỳ. Mục tiêu 3 tháng: đạt 450–500.',
    };
  }
  if (score <= 10) {
    return {
      level: 'Intermediate',
      toeicRange: 'TOEIC ~450–650',
      color: 'yellow',
      description:
        'Bạn đã có nền tảng nhất định. Với lộ trình đúng hướng, mục tiêu 700+ hoàn toàn trong tầm tay trong 2–3 tháng.',
      roadmap:
        'Hệ thống lại ngữ pháp → Nâng vốn từ theo chủ đề → Luyện Part 3–4 & Part 6–7 → Thi thử ETS. Mục tiêu: 650–750.',
    };
  }
  return {
    level: 'Upper-Intermediate',
    toeicRange: 'TOEIC ~700–850',
    color: 'teal',
    description:
      'Bạn có trình độ khá tốt! Cần tập trung vào chiến thuật làm bài và tốc độ để đạt 850–900+.',
    roadmap:
      'Test-taking strategy nâng cao → Phân tích lỗi sai → Luyện tốc độ Part 5–7 → Thi thử full test. Mục tiêu: 850–900+.',
  };
}
